import Vue from "vue";
import { Button } from "vant";

Vue.use(Button);
import { NavBar } from "vant";

Vue.use(NavBar);
import { Icon } from "vant";

Vue.use(Icon);
import { Image } from "vant";

Vue.use(Image);
import { Search } from "vant";

Vue.use(Search);
import { Swipe, SwipeItem } from "vant";

Vue.use(Swipe).use(SwipeItem);
// import { Tab, Tabs } from "vant";

// Vue.use(Tab).use(Tabs);
import { Tabbar, TabbarItem } from "vant";

Vue.use(Tabbar).use(TabbarItem);
import { Loading } from "vant";

Vue.use(Loading);
import { Divider } from "vant";

Vue.use(Divider);
import { List } from "vant";

Vue.use(List);
import { Sidebar, SidebarItem } from "vant";

Vue.use(Sidebar);
Vue.use(SidebarItem);
import { Tab, Tabs } from "vant";

Vue.use(Tab).use(Tabs);
import { Rate } from "vant";

Vue.use(Rate);
import { Tag } from "vant";

Vue.use(Tag);
import { Grid, GridItem } from "vant";

Vue.use(Grid).use(GridItem);
import { Lazyload } from "vant";

// options 为可选参数，无则不传
Vue.use(Lazyload);
import { Sticky } from "vant";

Vue.use(Sticky);
import { Popup } from "vant";

Vue.use(Popup);
import { Toast } from "vant";

Vue.use(Toast);
import { Slider } from "vant";

Vue.use(Slider);
